// 存储消息的key
export const MESSAGE_KEY = 'jkt-visitor'
// 存储 asstoken 的key
export const ACCESS_TOKEN_KEY = 'jkt-visitor-access-token'
// 存储 refreshToken 的key
export const REFRESH_TOKEN_KEY = 'jkt-visitor-refresh-token'